export const endpointName = 'Comment';
export const deleteCommentEndpoint = 'Comment/Delete';
export const getCommentEndpoint = 'Comment';
export const updateCommentEndpoint = 'Comment/Update';
export const createCommentEndpoint = 'Comment';
